import {
  QuickPanelDock as QuickPanelDockShell,
  QuickPanelDockButton,
  QuickPanelDockFab,
} from '@zrsystem/ui';
import { useState } from 'react';

import { useQuickPanelContext } from '@/app/surfaces/quick-panel-provider.js';
import { quickPanelRegistry } from '@/app/surfaces/quick-panel-registry.js';

const DOCK_ENTRIES = Object.entries(quickPanelRegistry)
  .filter(([, entry]) => entry.shortcut !== undefined)
  .sort(([, left], [, right]) => (left.shortcut ?? 0) - (right.shortcut ?? 0));

export function QuickPanelDock() {
  const { isOpen, toggleQuickPanel } = useQuickPanelContext();
  const [expanded, setExpanded] = useState(true);

  if (DOCK_ENTRIES.length === 0) {
    return null;
  }

  return (
    <QuickPanelDockFab expanded={expanded} onExpandedChange={setExpanded} hidden>
      <QuickPanelDockShell>
        {DOCK_ENTRIES.map(([key, entry]) => (
          <QuickPanelDockButton
            key={key}
            open={isOpen(key)}
            aria-label={entry.title}
            title={`${entry.title} (Alt+${entry.shortcut})`}
            onClick={() => {
              toggleQuickPanel(key);
            }}
          >
            {entry.dockLabel}
          </QuickPanelDockButton>
        ))}
      </QuickPanelDockShell>
    </QuickPanelDockFab>
  );
}
